import { IGenericResource } from 'api-client/qbert.model'
import { StorageClassesItem } from '../../resources/storage-classes/model'
import { IPersistentVolumeSelector } from 'k8s/components/resources/persistent-volume/model'

export enum IPersistentVolumeClaimDetailsPageTabs {
  Overview = 'overview',
  Yaml = 'yaml',
}

export interface PodsMounted {
  pod: string
  container: string
  path: string
}

export interface IPersistentVolumeClaimsSelector
  extends IGenericResource<PersistentVolumeClaimsItem> {
  labels: PersistentVolumeClaimsItem['metadata']['labels']
  accessModes: PersistentVolumeClaimsItem['spec']['accessModes']
  storageClassName: PersistentVolumeClaimsItem['spec']['storageClassName']
  storageClass: StorageClassesItem
  volume: string
  capacity: PersistentVolumeClaimsItem['status']['capacity']
  clusterName: string
  type: string
  podsMounted?: PodsMounted[]
  persistentVolume: IPersistentVolumeSelector
  age: string
}

export interface PersistentVolumeClaimsResponse {
  kind: string
  apiVersion: string
  metadata: PersistentVolumeClaimsResponseMetadata
  items: PersistentVolumeClaimsItem[]
}

export interface PersistentVolumeClaimsItem {
  metadata: ItemMetadata
  parameters?: { [key: string]: any }
  spec: Spec
  status: Status
}

interface ItemMetadata {
  name: string
  namespace: string
  uid: string
  resourceVersion: string
  creationTimestamp: string
  labels: Record<string, string>
  annotations: Record<string, string>
  finalizers: string[]
}

interface Spec {
  accessModes: string[]
  resources: Resources
  volumeName: string
  storageClassName: string
  volumeMode: string
}

interface Resources {
  requests: Capacity
}

interface Capacity {
  storage: string
}

interface Condition {
  type: string
  status: string
  lastHeartbeatTime?: string
  lastTransitionTime: string
  reason?: string
  message?: string
}

interface Status {
  phase: string
  accessModes: string[]
  capacity: Capacity
  conditions: Condition[]
}

interface PersistentVolumeClaimsResponseMetadata {
  resourceVersion: string
}

export type IClusterStatus =
  | 'ok'
  | 'pause'
  | 'fail'
  | 'unknown'
  | 'error'
  | 'loading'
  | 'upgrade'
  | 'pending'
  | 'degraded'
